import React from "react";
import { Link } from "react-router-dom";
import Bgimg from "../../assets/images/resources/service-sidebar-d-1.png";
import Serviceimg1 from "../../assets/images/resources/service-d-1.png";
import Servicedtlsimg from "../../assets/images/resources/service-details-p-1.png";

function InternshipTrainingPrograms() {
  return (
    <>
      <section className="service-details">
        <div className="container">
          <div className="row gutter-y-30">
            <div className="col-md-12 col-lg-4">
              <div className="service-sidebar">
                <div className="service-sidebar__single">
                  <ul className="list-unstyled service-sidebar__nav">
                    <ul>
                      <li>
                        <Link to="/it-recruitment">IT Recruitment</Link>
                      </li>
                      <li>
                        <Link to="/non-it-recruitment">Non-IT Recruitment</Link>
                      </li>
                      <li>
                        <Link to="/digital-marketing">Digital Marketing</Link>
                      </li>
                      <li>
                        <Link to="/executive-search">Executive Search</Link>
                      </li>
                      <li>
                        <Link to="/campus-hiring">Campus Hiring</Link>
                      </li>
                      <li>
                        <Link to="/internship-training">
                          Internship & Training Programs
                        </Link>
                      </li>
                      <li>
                        {" "}
                        <Link to="/hr-consulting">HR Consulting</Link>
                      </li>
                      <li>
                        <Link to="/career-guidance">
                          Career Guidance & Placement Assistance
                        </Link>
                      </li>
                      <li>
                        <Link to="/digital-hiringsolutions">
                          Digital HiringSolutions
                        </Link>
                      </li>
                    </ul>
                  </ul>
                </div>
                <div className="service-sidebar__single ">
                  <div
                    className="service-sidebar__contact background-base"
                    style={{ backgroundImage: `url(${Bgimg})` }}
                  >
                    <h3 className="service-sidebar__contact__title">
                      Recruitment Solutions for all Businesses
                    </h3>
                    <Link className="hiredots-btn" to="/contact">
                      {" "}
                      Contact
                    </Link>
                  </div>
                </div>
                <div className="service-sidebar__single ">
                  <div className="service-sidebar__download background-primary">
                    <div className="service-sidebar__download__icon">
                      <i className="icon-pdf-file" />
                    </div>
                    <div className="serice-sidebar__download">
                      <h3 className="service-sidebar__download__title">
                        <Link to="#">Project Agreement Form</Link>
                      </h3>
                      <p className="service-sidebar__download__number">3.9KB</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-12 col-lg-8">
              <div className="service-details__content">
                <div className="service-details__thumbnail">
                  <img src={Serviceimg1} alt="Staffing Solution" />
                </div>
                <h3 className="service-details__title">
                  Internship Training Programs
                </h3>
                <p className="service-details__text">
                  We offer internship opportunities, technical training, soft
                  skills development, professional certification support, and
                  career-readiness programs designed to improve employability.
                </p>
                <h3 className="service-details__lighlight">
                  How Do We Provide the Service?
                </h3>
                <p className="service-details__text">
                  Our programs combine classroom learning, hands-on projects,
                  mentorship, workshops, and practical industry exposure.
                  Participants gain real-world experience while developing
                  technical and professional competencies required by employers.
                </p>
                <h3 className="service-details__title">
                  Why Should You Choose Us?
                </h3>
                <div className="list-unstyled service-details__process">
                  <div className="row">
                    <div className="col-md-4">
                      <div className="service-details__process__top item-1">
                        <h4 className="service-details__process__title">
                          Industry training
                        </h4>
                        <span className="service-details__process__icon">
                          <i className="icon-individual" />
                        </span>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="service-details__process__top item-2">
                        <h4 className="service-details__process__title">
                          Practical learning
                        </h4>
                        <span className="service-details__process__icon">
                          <i className="icon-time-check" />
                        </span>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="service-details__process__top item-3">
                        <h4 className="service-details__process__title">
                          Expert mentors
                        </h4>
                        <span className="service-details__process__icon">
                          <i className="icon-report-card" />
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row gutter-y-30 align-items-center">
                  <div className="col-md-6">
                    <div className="service-details__image__circle">
                      <img src={Servicedtlsimg} alt="" />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <h4 className="service-details_list-title">Benefits</h4>

                    <ul className="list-unstyled service-details__list">
                      <li>
                        <i className="fas fa-check-circle" /> Enhanced job
                        readiness{" "}
                      </li>
                      <li>
                        <i className="fas fa-check-circle" /> Improved technical
                        and professional skills
                      </li>
                      <li>
                        <i className="fas fa-check-circle" /> Greater confidence
                        in workplace environments
                      </li>
                      <li>
                        <i className="fas fa-check-circle" /> Better career
                        opportunities
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default InternshipTrainingPrograms;
